import {
  ADD_BOOK,
  DELETE_BOOK,
  EDIT_BOOK,
  LOADED_BOOK,
  UPDATE_BOOK
} from './actionTypes';

export const loadedBooks = book => ({
  type: LOADED_BOOK,
  payload: book,
});
export const addBookItem = newBook => ({
  type: ADD_BOOK,
  payload: newBook,
});
export const deleteBookItem = bookId => ({
  type: DELETE_BOOK,
  payload: bookId,
});
export const editBookItem = bookId => ({
  type: EDIT_BOOK,
  payload: bookId,
});
export const updateBookItem = (bookId, updateBook) => ({
  type: UPDATE_BOOK,
  payload: {
    id: bookId,
    ...updateBook,
  },
});
